import { render, staticRenderFns } from "./OwnerListAlert.vue?vue&type=template&id=0a8d8e74"
import script from "./OwnerListAlert.vue?vue&type=script&lang=js"
export * from "./OwnerListAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports